import styled from 'styled-components'
import { RADOM_COLORS, WINDOW_SIZE } from '../../util/Constants'

export const SettingsPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: min(1040px, 100%);
`

export const SettingsHero = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 10px;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${WINDOW_SIZE.MOBILE_LARGE}) {
    flex-direction: column;
  }
`

export const SettingsEyebrow = styled.div`
  color: var(--text-soft, #7d8492);
  font-size: 10.5px;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

export const SettingsTitle = styled.div`
  color: var(--ink, #20242d);
  font-size: 20px;
  font-weight: 500;
  margin-top: 4px;
`

export const SettingsSubtext = styled.div`
  color: var(--text-muted, #687083);
  font-size: 12.5px;
  line-height: 1.45;
  margin-top: 6px;
  max-width: 680px;
`

export const SettingsCard = styled.section`
  background: var(--surface, #fff);
  border-radius: 14px;
  overflow: hidden;
`

export const SettingsCardHeader = styled.div`
  align-items: flex-start;
  background: var(--surface-subtle, #fbfcfe);
  border-bottom: 1px solid var(--hairline, #edf1f7);
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 14px 15px;

  @media (max-width: ${WINDOW_SIZE.MOBILE_LARGE}) {
    flex-direction: column;
  }
`

export const SettingsCardBody = styled.div`
`

export const SettingsCardTitle = styled.div`
  color: var(--ink, #20242d);
  font-size: 14px;
  font-weight: 500;
`

export const SettingsCardDescription = styled.div`
  color: var(--text-muted, #727888);
  font-size: 11.5px;
  line-height: 1.45;
  margin-top: 4px;
`

export const SettingsRows = styled.div`
  border: 1px solid var(--hairline, #edf1f7);
  border-radius: 14px;
  overflow: hidden;
`

export const SettingsRow = styled.div`
  align-items: center;
  border-bottom: 1px solid var(--hairline, #edf1f7);
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 11px 12px;

  &:last-child {
    border-bottom: 0;
  }

  @media (max-width: ${WINDOW_SIZE.MOBILE_LARGE}) {
    align-items: flex-start;
    grid-template-columns: 1fr;
  }
`

export const SettingsRowTitle = styled.div`
  color: var(--ink, #20242d);
  font-size: 12.5px;
  font-weight: 500;
`

export const SettingsRowDescription = styled.div`
  color: var(--text-muted, #727888);
  font-size: 11.5px;
  line-height: 1.4;
  margin-top: 4px;
`

export const SettingsGrid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (max-width: ${WINDOW_SIZE.TABLET}) {
    grid-template-columns: 1fr;
  }
`

export const StatusPill = styled.span<{ $tone?: 'green' | 'amber' | 'neutral' }>`
  background: ${({ $tone }) => $tone === 'green'
    ? 'var(--pill-green-bg, #e4f7ee)'
    : $tone === 'amber' ? 'var(--pill-amber-bg, #fff7ed)' : 'var(--pill-neutral-bg, #eef2f8)'};
  border-radius: 999px;
  color: ${({ $tone }) => $tone === 'green'
    ? 'var(--pill-green-ink, #11724f)'
    : $tone === 'amber' ? 'var(--pill-amber-ink, #b45309)' : 'var(--pill-neutral-ink, #657083)'};
  display: inline-flex;
  font-size: 10.5px;
  font-weight: 500;
  padding: 5px 9px;
  white-space: nowrap;
`

export const MutedValue = styled.div`
  color: ${RADOM_COLORS.GRAY_DARKEST};
  font-size: 11.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
